// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4b66f646] .bjs-powered-by,[data-v-4b66f646] .djs-palette{display:none}", ""]);
// Exports
module.exports = exports;
